import ReactDOM from "react-dom/client";
import React from "react";
import AppController from "./controller/AppController";
import "./resources/css/style.css";

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <AppController />
)